function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.142 16.069a.327.327 0 01-.089-.279c.049-.306.073-.616.073-.926.005-2.693-1.824-5.028-4.396-5.61a.315.315 0 01-.214-.174c-1.552-3.31-4.924-5.316-8.507-5.058-3.582.258-6.647 2.727-7.729 6.226a.316.316 0 01-.256.222C2.79 11.06-.271 14.904.02 19.26.309 23.617 3.852 27 8.125 27h15.626c2.534 0 4.818-1.565 5.78-3.962.963-2.396.414-5.149-1.389-6.97zM28 20.93c0 2.248-1.75 4.07-3.908 4.07H7.81C4.572 24.97 1.971 22.212 2 18.84c.03-3.371 2.677-6.08 5.915-6.05.636 0 1.18-.479 1.284-1.133.493-3.05 2.905-5.367 5.865-5.632 2.959-.265 5.715 1.588 6.702 4.506.176.523.64.881 1.172.905a3.23 3.23 0 012.567 1.514c.575.902.701 2.036.34 3.051-.206.58-.01 1.233.477 1.586 1.051.761 1.678 2.01 1.678 3.343z",
  fill: "currentColor"
})));